import React, { Component } from "react";
import PropTypes from "prop-types";
import { wrapComponent } from "../utils/container";
import { Grid, Button } from "material-ui";
import { Link } from "react-router-dom";
import FavoriteIcon from "material-ui-icons/Favorite";
import FaceIcon from "material-ui-icons/Face";
import { blue, grey } from "material-ui/colors";

const styleSheet = theme => ({
    root: {
        maxWidth: "900px",
        width: "100%",
        margin: "auto"
    },
    rootSecondary: {
        width: "100%",
        margin: "auto",
        padding: "24px 0",
        backgroundColor: blue[500]
    },
    flex: {
        flex: 1
    },
    iconPrimary: {
        textAlign: "center",
        height: 60,
        color: grey[200],
        width: 60
    },
    iconSecondary: {
        textAlign: "center",
        height: 60,
        width: 60,
        color: theme.palette.secondary[500]
    },
    iconContainer: {
        margin: "auto",
        textAlign: "center",
        paddingTop: "24px"
    },
    imageContainer: {
        margin: 24,
        textAlign: "center"
    },
    paperPrimary: {
        ...theme.typography.display1,
        marginLeft: "auto",
        textAlign: "center",
        maxWidth: "600px",
        margin: "auto",
        padding: "24px 24px 12px 24px",
        color: theme.palette.text.primary
    },
    paperSecondary: {
        ...theme.typography.subheading,
        textAlign: "center",
        maxWidth: "600px",
        margin: "auto",
        padding: "12px 24px 12px 24px",
        color: theme.palette.text.secondary
    },
    paperAccent: {
        ...theme.typography.subheading,
        textAlign: "center",
        maxWidth: "600px",
        margin: "auto",
        padding: "24px 24px 12px 24px",
        color: "white"
    },
    paperAccentTitle: {
        ...theme.typography.display1,
        marginLeft: "auto",
        textAlign: "center",
        maxWidth: "600px",
        margin: "auto",
        padding: "24px 24px 12px 24px",
        color: "white"
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20
    },
    screenshot: {
        maxWidth: 400,
        maxHeight: 400,
        height: "100%",
        width: "100%"
    }
});

class FrontLandingPage extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired
    };

    renderContents() {
        const { classes, t } = this.props;
        return (
            <div>
                <div className={classes.root}>
                    <Grid container spacing={0}>
                        <Grid item xs={12}>
                            <div className={classes.paperPrimary}>
                                {t(
                                    "frontLandingPage.Learn by writing with others"
                                )}
                            </div>
                            <div className={classes.paperSecondary}>
                                {t("frontLandingPage.Draft a composition")}
                            </div>
                            <div className={classes.paperSecondary}>
                                <Button
                                    component={Link}
                                    to="/login"
                                    raised
                                    color="accent"
                                    className={classes.button}>
                                    {t(
                                        "frontLandingPage.Create an account (Free)"
                                    )}
                                </Button>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={classes.imageContainer}>
                                <img
                                    alt={t("frontLandingPage.screenshot")}
                                    className={classes.screenshot}
                                    src={t("frontLandingPage.screenshotURL")}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div className={classes.rootSecondary}>
                    <div className={classes.root}>
                        <Grid container spacing={0}>
                            <Grid item xs={12}>
                                <div className={classes.paperAccentTitle}>
                                    {t(
                                        "frontLandingPage.A fun way to do language exchange"
                                    )}
                                </div>
                                <div className={classes.paperAccent}>
                                    {t("frontLandingPage.Post in the language")}
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className={classes.iconContainer}>
                                    <FaceIcon className={classes.iconPrimary} />
                                </div>
                                <div className={classes.paperAccentTitle}>
                                    {t(
                                        "frontLandingPage.Join a community of language lovers"
                                    )}
                                </div>
                                <div className={classes.paperAccent}>
                                    {t(
                                        "frontLandingPage.Engage with our entire community of"
                                    )}
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div className={classes.iconContainer}>
                                    <FavoriteIcon
                                        className={classes.iconSecondary}
                                    />
                                </div>
                                <div className={classes.paperAccentTitle}>
                                    {t(
                                        "frontLandingPage.Made with love, free forever"
                                    )}
                                </div>
                                <div className={classes.paperAccent}>
                                    {t(
                                        "frontLandingPage.Modole is a passion project"
                                    )}
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
                <div className={classes.root}>
                    <Grid container spacing={0}>
                        <Grid item xs={12}>
                            <div className={classes.paperSecondary}>
                                {t(
                                    "frontLandingPage.Have a question? Leave use feedback at"
                                )}
                                <a
                                    className={classes.emailLink}
                                    href="mailto:help@modole.io">
                                    help@modole.io
                                </a>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
    render() {
        return (
            <div>
                {this.renderContents()}
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}

export default wrapComponent(FrontLandingPage, styleSheet, mapStateToProps);



// WEBPACK FOOTER //
// ./src/containers/FrontLandingPage.jsx